import api from "@core/plugins/api";
import { SubscriptionFeedbackDto } from "@core/dto";

const getSubscriptionOffersUrl = () => `/subscription-highlight/et/all-offers`;
const getSubscriptionOffersByIdUrl = (demandId) => `/subscription-highlight/et/all-offers/${demandId}`;
const getPaymentSessionUrl = (id) => `/subscription-highlight/et/payment-methods/offer/${id}`;
const getPaymentLinkUrl = (code, offerId) => `/subscription-highlight/et/links/${code}/offer/${offerId}`;
const getSubscribedInformationsUrl = () => `/subscription-highlight/et/subscription`;
const postSubscriptionUrl = (offerId) => `subscription-highlight/et/offer/${offerId}`;
const shouldAdvertiseSubscriptionUrl = (demandId) => `/subscription-highlight/et/is-displayable/${demandId}`;
const getSubscriptionContentUrl = () => `/subscription-highlight/et/content`;
const getSubscriptionContentFromIdUrl = (demandId) => `/subscription-highlight/et/content/${demandId}`;
const subscriptionFeedbackUrl = () => `/subscription-highlight/et/feedback`;

export class EtabSubscriptionService {
  static async getSubscriptionOffers(demandId) {
    try {
      let url;
      if (demandId) {
        url = getSubscriptionOffersByIdUrl(demandId);
      } else {
        url = getSubscriptionOffersUrl();
      }
      const { data } = await api.private.get(url);
      return data?.offers;
    } catch (error) {
      throw error;
    }
  }

  static async getSubscribedInformations() {
    try {
      const { data } = await api.private.get(getSubscribedInformationsUrl());
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getPaymentSessions(id) {
    try {
      const { data } = await api.private.get(getPaymentSessionUrl(id));
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getPaymentLink({ code, offerId }) {
    try {
      const { data } = await api.private.get(getPaymentLinkUrl(code, offerId));
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async postSubscription(offerId) {
    try {
      const { data } = await api.private.post(postSubscriptionUrl(offerId));
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async shouldAdvertiseSubscription({ demandId }) {
    try {
      const { data } = await api.private.get(shouldAdvertiseSubscriptionUrl(demandId));
      return data === true;
    } catch (error) {
      throw error;
    }
  }

  static async getSubscriptionContentFromId({ demandId }) {
    try {
      const { data } = await api.private.get(getSubscriptionContentFromIdUrl(demandId));
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getSubscriptionContent() {
    try {
      const { data } = await api.private.get(getSubscriptionContentUrl());
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async giveFeedback({ highlightId, isInterested, offerId }) {
    try {
      const dto = new SubscriptionFeedbackDto();
      const feedBackdata = dto.prepareFeedbackData({ highlightId, isInterested, offerId });
      const { data } = await api.private.put(subscriptionFeedbackUrl(), feedBackdata);
      return data;
    } catch (error) {
      throw error;
    }
  }
}
